"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/dropdown/style/css");

var _dropdown = _interopRequireDefault(require("antd/es/dropdown"));

require("antd/es/menu/style/css");

var _menu = _interopRequireDefault(require("antd/es/menu"));

require("antd/es/tooltip/style/css");

var _tooltip = _interopRequireDefault(require("antd/es/tooltip"));

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/list/style/css");

var _list = _interopRequireDefault(require("antd/es/list"));

var _lodash = require("lodash");

var _icons = require("@ant-design/icons");

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _notification = require("../../redux/notification/notification.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./newQnaPostForm.scss");

var _QnaCommentList = _interopRequireDefault(require("./QnaCommentList"));

var _QnaFormContainer = _interopRequireDefault(require("./QnaFormContainer"));

var _Username = _interopRequireDefault(require("../username/Username"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _list.default;

class QnaDetailCard extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewForm: false,
      isNotificationPopupVisible: false
    };

    this.renderDate = value => {
      if (!value) {
        return 'N/a';
      }

      return (0, _moment.default)(value).calendar();
    };

    this.allcaps = s => s.toUpperCase();

    this.copyDeepLink = id => {
      const deepLink = `hmp://qna/${id}`;
      navigator.clipboard.writeText(deepLink).then(() => {
        _message2.default.success('Copied to clipboard!');
      }, () => {
        _message2.default.error('Failed to copy to clipboard.');
      });
    };

    this.deletePost = () => {
      const {
        post,
        deleteQnaPost
      } = this.props;

      if (post.id) {
        deleteQnaPost(post.id);
      }
    };

    this.showQnaForm = () => {
      this.setState({
        viewForm: true
      });
    };

    this.closeQnaForm = () => {
      this.setState({
        viewForm: false
      });
    };

    this.showAdHocNotificationPopover = () => {
      this.setState({
        isNotificationPopupVisible: true
      });
    };

    this.handleActionsDropdownVisibleChange = flag => {
      if (!flag) {
        this.setState({
          isNotificationPopupVisible: flag
        });
      }
    };

    this.froalaRef = /*#__PURE__*/_react.default.createRef();
  }

  handleNotificationPopoverVisibleChange(visible) {
    this.setState({
      isNotificationPopupVisible: visible
    });
  }

  sendAdHocNotification(userId) {
    const {
      id: qnaPostId
    } = this.props.post;
    const {
      sendAdHocAdminQnaNotification
    } = this.props;

    if (qnaPostId) {
      sendAdHocAdminQnaNotification({
        userId,
        qnaPostId
      });
    }

    this.setState({
      isNotificationPopupVisible: false
    });
  }

  render() {
    const {
      viewForm
    } = this.state;
    const {
      post,
      experts
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "hmp-qna-detail-card"
    }, viewForm && /*#__PURE__*/_react.default.createElement(_QnaFormContainer.default, {
      visible: viewForm,
      closeHandler: this.closeQnaForm,
      post: _lodash._.cloneDeep(post)
    }), /*#__PURE__*/_react.default.createElement(_list.default, {
      bordered: true,
      itemLayout: "vertical",
      size: "large",
      dataSource: [post],
      renderItem: item => {
        const {
          id,
          favorites,
          thumbsups,
          comments,
          topic,
          question,
          answer,
          createdByParticipantId,
          createDate,
          adHocNotifications,
          deleteDate
        } = item;
        const commentCount = comments ? comments.length + comments.map(c => c.comments.length).reduce((sum, c) => sum + c, 0) : 0;

        const sendAdHocNotificationPopoverContent = /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            marginBottom: '10px'
          }
        }, experts.map(e => {
          return /*#__PURE__*/_react.default.createElement("div", {
            key: e.id,
            style: {
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              justifyContent: 'center',
              marginTop: '10px'
            }
          }, /*#__PURE__*/_react.default.createElement(_button.default, {
            style: {
              width: '90%'
            },
            onClick: () => this.sendAdHocNotification(e.id)
          }, /*#__PURE__*/_react.default.createElement(_icons.MailOutlined, null), ' ', e.username, ' '));
        }));

        let actions = [];

        const sendAdHocNotificationPopover = /*#__PURE__*/_react.default.createElement(_popover.default, {
          content: sendAdHocNotificationPopoverContent,
          title: "Notify Expert of this post",
          trigger: "click",
          visible: this.state.isNotificationPopupVisible,
          onVisibleChange: this.handleNotificationPopoverVisibleChange.bind(this)
        }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          placement: "bottom",
          title: () => {
            return /*#__PURE__*/_react.default.createElement("div", null, (adHocNotifications || []).map(n => /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("b", null, n.username), ' ', (0, _moment.default)(n.createDate).calendar(), ' ', /*#__PURE__*/_react.default.createElement("br", null), ' ', /*#__PURE__*/_react.default.createElement("b", null, "Email:"), ' ', n.emailResult.success ? 'success' : n.emailResult.err, ' ', /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("b", null, "SMS:"), ' ', n.smsResult.success ? 'success' : n.smsResult.err, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null))));
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-icon",
          key: "list-vertical-mail"
        }, /*#__PURE__*/_react.default.createElement(_icons.MailOutlined, {
          style: {
            marginRight: 8
          }
        }), (adHocNotifications === null || adHocNotifications === void 0 ? void 0 : adHocNotifications.length) ? adHocNotifications[0].username : 'Notify')));

        const dropdownMenu = /*#__PURE__*/_react.default.createElement(_menu.default, null, /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
          key: "delete",
          title: "Delete post",
          className: "qna-action",
          onClick: e => this.deletePost()
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "fal fa-trash-alt"
        }), ' ', "Delete"), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
          key: "edit",
          title: "Edit",
          className: "qna-action",
          onClick: e => this.showQnaForm()
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "far fa-edit"
        }), ' ', "Edit"), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
          key: "notify",
          title: "Notify expert",
          className: "qna-action",
          onClick: e => this.showAdHocNotificationPopover()
        }, sendAdHocNotificationPopover));

        actions = actions.concat([/*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-username"
        }, /*#__PURE__*/_react.default.createElement(_Username.default, {
          participantId: createdByParticipantId
        })), /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-date"
        }, this.renderDate(createDate)), /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-icon",
          key: "list-vertical-message"
        }, /*#__PURE__*/_react.default.createElement(_icons.MessageOutlined, {
          style: {
            marginRight: 8
          }
        }), commentCount), /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-icon",
          key: "list-vertical-like-o"
        }, /*#__PURE__*/_react.default.createElement(_icons.LikeOutlined, {
          style: {
            marginRight: 8
          }
        }), thumbsups ? thumbsups.length : 0), /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-icon",
          key: "list-vertical-like-o"
        }, /*#__PURE__*/_react.default.createElement(_icons.StarOutlined, {
          style: {
            marginRight: 8
          }
        }), favorites ? favorites.length : 0), /*#__PURE__*/_react.default.createElement("a", {
          title: "Copy deep link to clipboard",
          className: "qna-action",
          onClick: e => {
            e.stopPropagation();
            this.copyDeepLink(id);
          }
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "far fa-link"
        })), /*#__PURE__*/_react.default.createElement(_dropdown.default, {
          trigger: ['click'],
          overlay: dropdownMenu,
          onVisibleChange: this.handleActionsDropdownVisibleChange
        }, /*#__PURE__*/_react.default.createElement("a", {
          className: "hmp-qna-icon"
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "far fa-ellipsis-h fa-lg"
        })))]);
        const tags = [];

        if (deleteDate !== undefined && deleteDate !== null) {
          tags.push( /*#__PURE__*/_react.default.createElement("span", {
            title: (0, _moment.default)(deleteDate).calendar(),
            className: "post-tag-bubble deleted"
          }, "DELETED"));
        }

        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Item, {
          key: `qna-post-${id}`,
          actions: actions
        }, /*#__PURE__*/_react.default.createElement(Item.Meta, {
          title: `Q: ${question}`
        }), answer ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, "Answer:"), /*#__PURE__*/_react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: answer
          }
        })) : '(Unanswered)', /*#__PURE__*/_react.default.createElement("div", {
          className: "hmp-qna-topic-container"
        }, tags, /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-topic"
        }, this.allcaps(topic)))), /*#__PURE__*/_react.default.createElement(_QnaCommentList.default, {
          level: 0,
          comments: comments
        }));
      }
    }));
  }

}

const mapStateToProps = state => {
  return {
    experts: selectors.getExpertAdmin(state),
    studyId: selectors.getRequestedStudyId(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    sendAdHocAdminQnaNotification: val => dispatch(_notification.sendAdHocAdminQnaNotificationAsync.request(val))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QnaDetailCard);

exports.default = _default;